import { useMemo } from "react";
import { createLazyFileRoute } from "@tanstack/react-router";

import { SvRidingProjections } from "@/components/SvRidingProjections/SvRidingProjections.tsx";
import { useRidingsQuery } from "@/data/queries/RidingQueries.ts";

const Riding = () => {
  const { election, riding } = Route.useParams();

  const { data: ridingsData } = useRidingsQuery(election);

  const currentRidingData = useMemo(() => {
    if (!riding || !ridingsData) return null;
    return ridingsData?.find(r => r.ridingNumber === riding);
  }, [ridingsData, riding]);

  if (!currentRidingData) {
    return null;
  }
  return <SvRidingProjections ridingData={currentRidingData} />;
};

export const Route = createLazyFileRoute("/ridings/$election/$riding")({
  component: Riding,
});
